import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useUpdateEmail = () =>
  useMutation({
    mutationFn: updateEmail,
  });

const updateEmail = async (props: UpdateEmailBody) =>
  api.put<void>(apiConfig.routes.auth.updateEmail, props);

type UpdateEmailBody = {
  email: string;
};
